import Util from 'app/util'

import getters from './games/getters.js'
import mutations from './games/mutations.js'
import actions from './games/actions.js'

export default {

	namespaced: true,

	state: {

		name: 'list',

		route: 'List',

		data: Util.filter.templates.list(),

		defaultValues: Util.filter.templates.list(),

		preset: 0,

		changed: false

	},
	
	getters: getters,
	mutations: mutations,
	actions: actions

}